<template>
    <div
        class="confirm-snackbar"
        :id="id"
    >
        <p>{{ message }}</p>
        <button
            type="button"
            class="btn btn-primary btn-sm"
            @click="callback()"
        >
            {{ $t('yes') }}
        </button>
        <button
            type="button"
            class="btn btn-secondary btn-sm"
            @click="dismiss()"
        >
            {{ $t('no') }}
        </button>
    </div>
</template>

<script lang="ts">
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable no-undef */

import Vue from 'vue';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { Helper } from '@/utils';

@Component({})
export default class ConfirmSnackbarComponent extends Vue {

    private id: string;

    @Prop()
    private open: boolean;

    @Prop()
    private message: any;

    @Prop()
    private callbackFunction: (() => void) | undefined;

    constructor () {
        super();
        this.id = Helper.generateGUID();
        this.open = false;
    }

    @Watch('open')
    private watchOpen(newVal: boolean, oldVal: boolean): void {
        if (newVal !== oldVal) {
            const self = this;
            if (newVal === true) {
                $('#' + self.id).addClass('open');
                this.addOverlay();
            } else {
                $('#' + this.id).removeClass('open');
                this.removeOverlay();
            }
        }
    }

    private callback(): void {
        this.$parent.$emit('closeConfirmSnackbar');
        setTimeout(() => {
            if (this.callbackFunction && typeof this.callbackFunction === 'function') {
                this.callbackFunction();
            }
        }, 250);
    }

    private dismiss(): void {
        this.$parent.$emit('closeConfirmSnackbar');
    }

    private addOverlay(): void {
        $('body').append('<div class="snackbar-overlay"></div>');
    }

    private removeOverlay(): void {
        $('.snackbar-overlay').remove();
    }
}
</script>

<style lang="less" >

.confirm-snackbar {
    background: #333;
    border-radius: 3px;
    position: fixed;
    width: 300px;
    left: 43%;
    top: -200px;
    height: inherit;
    color: #fff;
    padding: 10px;
    text-align: center;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
    transition: top 300ms ease-in-out;
    z-index: 1110;
    @media(min-width: 2024px) {
        font-size: 1.3rem;
        width: 380px;
    }
    button {
        margin: 0 10px;
        min-width: 70px;
        @media(min-width: 2024px) {
            font-size: 1.1rem;
        }
    }
}

.confirm-snackbar.open {
    top: 50px;
    transition: top 300ms ease-in-out;
}

.snackbar-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000;
    opacity: 0.3;
    z-index: 1100;
}
</style>
